import { useMemo } from 'react';
import usePlatformConfig from '../../../../common/react/usePlatformConfig';
import { IPriceWithTaxes } from '../../model/IPrice';
import { TaxTypes } from '../../../../../../common/enum/TaxTypes';
import ITaxes from '../../model/ITaxes';

const useTaxes = (prices: IPriceWithTaxes[]): ITaxes => {
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();

  const taxes = useMemo(
    () =>
      prices
        .find(p => p.taxes?.length && p.money.currency === priceDisplay.primary.currency)
        ?.taxes.reduce((acc: { [key: string]: number }, tax) => {
          acc[tax.type] = tax.money.amount;

          return acc;
        }, {}),
    [priceDisplay, prices],
  );

  return {
    novaTotalTax: taxes?.[TaxTypes.NOVA_TOTAL],
    frt: taxes?.[TaxTypes.FRT],
    vat: taxes?.[TaxTypes.VAT],
    handlingFee: taxes?.[TaxTypes.HANDLING_FEE],
    gst: taxes?.[TaxTypes.GST],
    gvt: taxes?.[TaxTypes.GVT],
  };
};

export default useTaxes;
